import { useEffect, useSyncExternalStore } from "react";
import { useAuth } from "@/auth/useAuth";
import { vb360Access } from "@/features/vb360/access/vb360-access";
import { vb360ContextStore } from "@/features/vb360/state/vb360-context-store";
import type { Vb360ContextState } from "@/features/vb360/state/vb360-context-store";

export const useVb360Context = (): Vb360ContextState => {
    const { state } = useAuth();
    const snapshot = useSyncExternalStore(vb360ContextStore.subscribe, vb360ContextStore.getState);
    const userId = state.user?.id ?? "";
    const authenticated = state.status === "authenticated";

    useEffect(() => {
        if (vb360Access.featureEnabled() === false) return;
        if (authenticated === false || userId === "") return;
        void vb360ContextStore.load(userId);
    }, [authenticated, userId]);

    return snapshot;
};
